export default "__VITE_ASSET__ce385bd8__"